import { Injectable } from '@angular/core';
import { IApiService } from '../modules/records/models/api/i-api-service';
import { Competitors } from '../modules/pages/hot-alert/configurations/competitors';
import { IPayload } from '../interface/filters';
import { genCompetitorsTableConfig } from '../modules/pages/on-rep-competitors/competitors-table-config';
import { AuthService } from './auth.service';
import { BehaviorSubject, Observable, catchError, map, of, switchMap, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApplicationService } from './application.service';
import { CompetitorsAdapter } from '../modules/pages/hot-alert/configurations/competitors-adapter';
import { HttpClient, HttpParams } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { MyUtils } from './my-utils.service';
import { CompetitorsDialogComponent } from '../shared/dialogs/competitors-dialog/competitors-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class CompetitorsService implements IApiService<Competitors> {

  listCompEnterprise: string[] = [];
  endpoint = environment.csibefrontend;
  isLoading = false;
  private _reports = new BehaviorSubject<Competitors[]>([]);
  constructor(
    private authService: AuthService, 
    private applicationService: ApplicationService,
    private competitorsAdapter: CompetitorsAdapter,
    private http: HttpClient,
    private dialog: MatDialog,
    private utils: MyUtils
    ) { }


  genTableConfig() {
    return genCompetitorsTableConfig(this, this.authService.meSelectValue);
}

private sendDeleteCompetitors(el: Competitors) {
  let body = this.competitorsAdapter.generateDeleteBody(el);
  return this.http.post(this.endpoint + "v1/deleteCompetitors", body);
}

delete(el: Competitors) {
  return this.sendDeleteCompetitors(el);
}

create() {
  return this.dialog
    .open(CompetitorsDialogComponent, {
      maxHeight: "100vh",
      maxWidth: "100vh",
      panelClass: "actionPlanDialog"
    })
    .afterClosed()
    .pipe(switchMap((formData) => (formData ? this.createCompetitors(formData) : of(null))));
}

getMaseratiCompetitorsList(){
  return this.http.get<any[]>(this.endpoint + "v1/getMaseratiCompetitorsList")
}

createCompetitors(formValue: any){
  let body = this.competitorsAdapter.generateCreateBody(formValue);
    return this.http.post(this.endpoint + `v1/addCompetitors`, body);
}

getAll(filter: IPayload) {
  let dealer: any = this.authService.meSelectValue?.dealer;
  let params = new HttpParams()
  .set("dealerId", dealer)
  this.isLoading = true;
  return this.http.get(this.endpoint + "v1/getCompetitorsByDealer",  {
    params
  })
  
  .pipe(
      map((res) => {
        const data = this.competitorsAdapter.mapCollection(res)
        return data
      }),
      tap((res) => this._reports.next(res.items)),
      tap((_) => (this.isLoading = false)),
      catchError((err) => {
          this.isLoading = false;
          return of(this.competitorsAdapter.mapCollection());
      })
  );
}

listCompetitorsEnterpriseId(): Observable<string[]>{
 return this.http.get<{brand_name: string, competitors_businessId: string}[]>(this.endpoint + "v1/getCompetitorsBrandList")
 .pipe(
  map(data => {
    const brandNames = data.map(el => el.brand_name)
    return brandNames
  })
 )
}

get hasMarket() {
  return (
    this.utils.settingsPayloadValue.payload.network.regions[0]?.subRegions[0]?.market.filter(
      (m) => !!m
    ).length > 0
  );
}

}
